import React from 'react';
import PropTypes from 'prop-types';

import { Quote, QuotationMark } from './text.styles';

const QuoteBlock = ({ children }) => (
  <Quote>
    <QuotationMark aria-hidden="true">“</QuotationMark>
    {children}
  </Quote>
);

QuoteBlock.propTypes = {
  children: PropTypes.node,
};

export default QuoteBlock;
